import Innerwrapper from "app/components/inner-wrapper/Innerwrapper";
import React from "react";
import "./payment-gateway.css";

function PaymentGateway() {
  return (
    <>
      <Innerwrapper>
        <div className="gateway">
          <h1>
            Payment
            <span>Gateway</span>
            Page
          </h1>
        </div>
      </Innerwrapper>
    </>
  );
}

export default PaymentGateway;
